import { PtoScreen } from "@/components/pto/PtoScreen";

export function PtoPage() {
  return <PtoScreen />;
}
